import { IUserInit } from "./interfaces/IUserInit";
import { userInitMap } from "./typeMaping/userInitMap";
import { CurrentUserRole } from "./types/CurrentUserRoleTypes";

export class UserInitFactory{
    public static createUserInit(currentUserRole: CurrentUserRole):IUserInit{
        const userInit = userInitMap[currentUserRole]();
        return userInit;
    }
}